<template>
  <v-menu
    location="bottom start"
    :close-on-content-click="false"
    v-model="closeMenu"
  >
    <template #activator="{ props }">
      <v-btn
        icon
        size="small"
        width="28"
        height="28"
        elevation="1"
        class="mx-1 background"
        @click="closeMenu = true"
        v-bind="props"
      >
        <v-icon size="small">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-title>
          <slot></slot>
        </v-list-item-title>
        <template #append>
          <base-sidebar-viewer-btn
            @click="closeMenu = false"
            icon="mdi-close"
            label="Close"
            btn-class="background"
            icon-color="grey"
            class="position-absolute"
            style="top: 8px; right: 8px; z-index: 1;"
          ></base-sidebar-viewer-btn>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'BaseViewHeaderMobileBtn',

  props: {
    icon: {
      type: String,
      default: 'mdi-magnify',
    },
  },

  data() {
    return {
      closeMenu: false,
    };
  },
};
</script>
